export default __webpack_public_path__ + "static/media/covid-lg.00778077.png";